import { style } from '@angular/animations';
import {
  Component,
  OnDestroy,
  OnInit,
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  Input,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { AuthModel } from '../../../../models/auth.model';
import { AuthService } from '../../../../services/auth.service';
import { ConfigService } from '../../../../services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { NhanVienService } from 'src/app/services/nhanvien.service';
import { NhanVienWarningModel } from 'src/app/models/nhanvienshort.model';
import { AppToastService } from 'src/app/services/app-toast.service';
import { AppConfigService } from 'src/app/services/app-config.service';
import { HttpStatus } from '../../../../models/model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent
  implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  items: MenuItem[];
  itemsProfile: MenuItem[];

  displayPosition: boolean;
  position: string;
  displayChangePassword: boolean;
  locale: string;

  @Input() active: boolean;

  displayNoti: boolean = false;

  authModel: AuthModel;
  canShowAdminManager: boolean;
  canShowUsers: boolean;
  canShowFunctions: boolean;
  canShowRoles: boolean;
  canShowNhanVien: boolean;
  canShowHopDongLaoDong: boolean;
  canShowEmployeeManager: boolean;
  canShowNhanVienDetail: boolean;
  canShowDmQuanHe: boolean;
  canShowLuong: boolean;
  canShowPhieuLuong: boolean;
  canShowLuongNangSuat: boolean;
  canShowPhuCap: boolean;
  canShowLuongCapBac: boolean;
  canShowQlLuong: boolean;
  canShowBaoHiem: boolean;
  canShowThueTncn: boolean;
  canShowDonVi: boolean;
  canShowTemplateLuong: boolean;
  canShowNangDinh: boolean;
  canShowKyLuat: boolean;
  canShowDthl: boolean;
  canShowLogs: boolean;
  canShowQlDaoTao: boolean;
  canShowLoaiPhuCap: boolean;
  canShowKhenThuongKyLuat: boolean;
  canShowQtct: boolean;
  canShowQtctDang: boolean;
  canShowQtctCongDoan: boolean;
  canShowQtctDoanThanhNien: boolean;
  canShowThamSoKyHieuCong: boolean;
  canShowNhomKyHieuCong: boolean;
  canShowConfigLuong: boolean;
  canShowQLChamCong: boolean;
  canShowQLAnCa: boolean;
  canShowQLThuNhap: boolean;

  canShowDangDoanThe: boolean;
  canShowChinhQuyen: boolean;
  canShowDang: boolean;
  canShowCongDoan: boolean;
  canShowDoanThanhNien: boolean;
  canShowKhenThuong: boolean;
  canShowKhenThuongDang: boolean;
  canShowKhenThuongCongDoan: boolean;
  canShowKhenThuongDoanThanhNien: boolean;
  canShowKyLuatDang: boolean;
  canShowKyluatCongDoan: boolean;
  canShowKyLuatDoanThanhNien: boolean;
  canShowNhanXetHangNam: boolean;
  canShowNhanXetHangNamDang: boolean;
  canShowNhanXetHangNamCongDoan: boolean;
  canShowNhanXetHangNamDoanThanhNien: boolean;
  canShowCaLamViec: boolean;
  canShowConfigLuongGio: boolean;

  listWarning: NhanVienWarningModel[];
  selectedNhanVien: NhanVienWarningModel;

  constructor(
    private router: Router,
    private authService: AuthService,
    private nhanVienService: NhanVienService,
    private toastService: AppToastService,
    private configService: ConfigService,
    private appConfigService: AppConfigService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.locale = localStorage.getItem('locale');
    if (!this.locale) {
      this.locale = this.translate.getDefaultLang();
      if (this.locale) {
        localStorage.setItem('locale', this.locale);
      } else {
        this.locale = 'vi';
        localStorage.setItem('locale', 'vi');
      }
    }
  }

  ngOnInit() {
    this.listWarning = new Array<NhanVienWarningModel>();
    this.authModel = this.authService.getUserInfoLocal();
    this.canShowKhenThuongDang = this.authService.hasPermission(
      this.configService.url.khenThuongDang?.index
    );
    this.canShowCaLamViec = this.authService.hasPermission(
      this.configService.url.caLamViec?.index
    );
    this.canShowKhenThuongCongDoan = this.authService.hasPermission(
      this.configService.url.khenThuongCongDoan?.index
    );
    this.canShowKhenThuongDoanThanhNien = this.authService.hasPermission(
      this.configService.url.khenThuongDoanThanhNien?.index
    );
    this.canShowKyLuatDang = this.authService.hasPermission(
      this.configService.url.kyLuatDang?.index
    );
    this.canShowKyluatCongDoan = this.authService.hasPermission(
      this.configService.url.kyLuatCongDoan?.index
    );
    this.canShowKyLuatDoanThanhNien = this.authService.hasPermission(
      this.configService.url.kyLuatDoanThanhNien?.index
    );
    this.canShowNhanXetHangNam = this.authService.hasPermission(
      this.configService.url.nhanXetHangNam?.index
    );
    this.canShowNhanXetHangNamDang = this.authService.hasPermission(
      this.configService.url.nhanXetHangNamDang?.index
    );
    this.canShowNhanXetHangNamCongDoan = this.authService.hasPermission(
      this.configService.url.nhanXetHangNamCongDoan?.index
    );
    this.canShowNhanXetHangNamDoanThanhNien = this.authService.hasPermission(
      this.configService.url.nhanXetHangNamDoanThanhNien?.index
    );
    this.canShowUsers = this.authService.hasPermission(
      this.configService.url.users.index
    );
    this.canShowFunctions = this.authService.hasPermission(
      this.configService.url.functions.index
    );
    this.canShowRoles = this.authService.hasPermission(
      this.configService.url.roles.index
    );
    this.canShowDmQuanHe = this.authService.hasPermission(
      this.configService.url.dmQuanHe.index
    );
    this.canShowDonVi = this.authService.hasPermission(
      this.configService.url.dmDonVi.index
    );
    this.canShowHopDongLaoDong = this.authService.hasPermission(
      this.configService.url.hopDongLaoDong.index
    );
    this.canShowTemplateLuong = this.authService.hasPermission(
      this.configService.url.templateLuong.index
    );
    this.canShowConfigLuongGio = this.authService.hasPermission(
      this.configService.url.configLuongGio.index
    );
    this.canShowThamSoKyHieuCong = this.authService.hasPermission(
      this.configService.url.thamSoKyHieuCong.index
    );
    this.canShowNhomKyHieuCong = this.authService.hasPermission(
      this.configService.url.nhomKyHieuCong.index
    );
    this.canShowConfigLuong = this.authService.hasPermission(
      this.configService.url.configLuong.getConfig
    );
    this.canShowQLAnCa = this.authService.hasPermission(
      this.configService.url.quanLyAnCa.index
    );
    this.canShowQLThuNhap = this.authService.hasPermission(
      this.configService.url.quanLyThuNhap.index
    );
    this.canShowQLChamCong = this.authService.hasPermission(
      this.configService.url.quanLyCong.index
    );
    this.canShowNhanVien = this.authService.hasPermission(
      this.configService.url.nhanvien.index
    );
    this.canShowNhanVienDetail = this.authService.hasPermission(
      this.configService.url.nhanvien.detail
    );
    this.canShowLuongNangSuat = this.authService.hasPermission(
      this.configService.url.dmLuongNangSuat.index
    );
    this.canShowLuongCapBac = this.authService.hasPermission(
      this.configService.url.dmLuongCapBac.index
    );
    this.canShowPhieuLuong = this.authService.hasPermission(
      this.configService.url.dmLuong.index
    );
    this.canShowPhuCap = this.authService.hasPermission(
      this.configService.url.dmPhuCap.index
    );
    this.canShowBaoHiem = this.authService.hasPermission(
      this.configService.url.baohiem.index
    );
    this.canShowThueTncn = this.authService.hasPermission(
      this.configService.url.thuetncn.index
    );
    this.canShowDthl = this.authService.hasPermission(
      this.configService.url.daoTaoHuanLuyen.index
    );
    this.canShowNangDinh = this.authService.hasPermission(
      this.configService.url.nangDinh.index
    );
    this.canShowKhenThuong = this.authService.hasPermission(
      this.configService.url.khenThuong.index
    );
    this.canShowKyLuat = this.authService.hasPermission(
      this.configService.url.kyLuat.index
    );
    this.canShowLogs = this.authService.hasPermission(
      this.configService.url.logs.index
    );
    this.canShowQtctDang = this.authService.hasPermission(
      this.configService.url.qtctDang.index
    );
    this.canShowLoaiPhuCap = this.authService.hasPermission(
      this.configService.url.dmLoaiPhuCap.index
    );
    this.canShowQtctDoanThanhNien = this.authService.hasPermission(
      this.configService.url.qtctDoanThanhNien.index
    );
    this.canShowQtctDoanThanhNien = this.authService.hasPermission(
      this.configService.url.qtctDoanThanhNien.index
    );

    this.canShowAdminManager =
      this.canShowFunctions ||
      this.canShowRoles ||
      this.canShowUsers ||
      this.canShowDmQuanHe ||
      this.canShowDonVi ||
      this.canShowTemplateLuong ||
      this.canShowThamSoKyHieuCong ||
      this.canShowNhomKyHieuCong ||
      this.canShowConfigLuong ||
      this.canShowLoaiPhuCap ||
      this.canShowLogs ||
      this.canShowConfigLuongGio;

    this.canShowLuong = this.canShowLuongCapBac || this.canShowLuongNangSuat || this.canShowPhieuLuong || this.canShowPhuCap;
    this.canShowQlLuong =
      this.canShowLuong || this.canShowBaoHiem || this.canShowThueTncn || this.canShowQLChamCong || 
      this.canShowQLAnCa || this.canShowQLThuNhap || this.canShowCaLamViec;
    this.canShowQlDaoTao = this.canShowDthl || this.canShowNangDinh;
    this.canShowKhenThuongKyLuat = this.canShowKhenThuong || this.canShowKyLuat || this.canShowNhanXetHangNam;
    this.canShowEmployeeManager = this.canShowNhanVien || this.canShowHopDongLaoDong;
    this.canShowQtct = this.canShowQtctDang || this.canShowQtctCongDoan || this.canShowQtctDoanThanhNien;
    this.canShowDang = this.canShowKhenThuongDang || this.canShowKyLuatDang || this.canShowQtctDang || this.canShowNhanXetHangNamDang;
    this.canShowCongDoan = this.canShowKhenThuongCongDoan || this.canShowKyluatCongDoan || this.canShowQtctCongDoan || this.canShowNhanXetHangNamCongDoan;
    this.canShowDoanThanhNien = this.canShowKhenThuongDoanThanhNien || this.canShowKyLuatDoanThanhNien || this.canShowQtctDoanThanhNien || this.canShowNhanXetHangNamDoanThanhNien;
    this.canShowDangDoanThe = this.canShowDang || this.canShowCongDoan || this.canShowDoanThanhNien;
    this.canShowChinhQuyen = this.canShowDang || this.canShowCongDoan || this.canShowDoanThanhNien;



    this.items = [
      {
        label: this.translate.instant('menu.system'),
        icon: 'pi pi-fw pi-sitemap',
        visible: this.canShowAdminManager,
        items: [
          {
            label: this.translate.instant('menu.users'),
            icon: 'pi pi-fw pi-users',
            routerLink: '/users',
            visible: this.canShowUsers,
          },
          {
            label: this.translate.instant('menu.roles'),
            icon: 'pi pi-fw pi-shield',
            routerLink: '/roles',
            visible: this.canShowRoles,
          },
          {
            label: this.translate.instant('menu.donvi'),
            icon: 'pi pi-fw pi-building',
            routerLink: '/donvi',
            visible: this.canShowDonVi,
          },
          {
            label: this.translate.instant('menu.thamsokyhieucong'),
            icon: 'pi pi-fw pi-cog',
            routerLink: '/thamsokyhieucong',
            visible: this.canShowThamSoKyHieuCong,
          },
          {
            label: this.translate.instant('menu.nhomkyhieucong'),
            icon: 'pi pi-fw pi-tags',
            routerLink: '/nhomkyhieucong',
            visible: this.canShowNhomKyHieuCong,
          },
          {
            label: this.translate.instant('menu.configluong'),
            icon: 'pi pi-fw pi-calculator',
            routerLink: '/configluong',
            visible: this.canShowConfigLuong,
          },
          {
            label: this.translate.instant('menu.loaiphucap'),
            icon: 'pi pi-fw pi-chart-line',
            routerLink: '/loaiphucap',
            visible: this.canShowLoaiPhuCap,
          },
          {
            label: this.translate.instant('menu.configluonggio'),
            icon: 'pi pi-fw pi-chart-line',
            routerLink: '/configluonggio',
            visible: this.canShowConfigLuongGio,
          },
          {
            label: this.translate.instant('menu.templateluong'),
            icon: 'pi pi-fw pi-file-excel',
            routerLink: '/templateluong',
            visible: this.canShowTemplateLuong,
          },
          {
            label: this.translate.instant('menu.quanhe'),
            icon: 'pi pi-fw pi-sitemap',
            routerLink: '/quanhe',
            visible: this.canShowDmQuanHe,
          },
          {
            label: this.translate.instant('menu.logs'),
            icon: 'pi pi-fw pi-file-o',
            routerLink: '/logs',
            visible: this.canShowLogs,
          },
        ],
      },
      {
        label: this.translate.instant('menu.employee'),
        icon: 'pi pi-fw pi-users',
        visible: this.canShowEmployeeManager,
        items: [
          {
            label: this.translate.instant('menu.employee'),
            icon: 'pi pi-fw pi-users',
            visible: this.canShowNhanVien,
            routerLinkActiveOptions: { exact: true },
            routerLink: 'nhanvien',
          },
          {
            label: this.translate.instant('menu.hopdonglaodong'),
            icon: 'pi pi-fw pi-briefcase',
            visible: this.canShowHopDongLaoDong,
            routerLinkActiveOptions: { exact: true },
            routerLink: 'hopdonglaodong',
          },
          {
            label: this.translate.instant('menu.employee-warning'),
            icon: 'pi pi-fw pi-exclamation-triangle',
            visible: this.canShowNhanVien,
            routerLinkActiveOptions: { exact: true },
            routerLink: 'nhanvien/warning',
          },
        ],
      },
      {
        label: this.translate.instant('menu.qlluong'),
        icon: 'pi pi-fw pi-money-bill',
        visible: this.canShowQlLuong,
        items: [
          {
            label: this.translate.instant('menu.luong'),
            icon: 'pi pi-fw pi-dollar',
            visible: this.canShowLuong,
            items: [
              {
                label: this.translate.instant('menu.phieuluong'),
                icon: 'pi pi-fw pi-credit-card',
                routerLink: '/phieuluong',
                visible: this.canShowPhieuLuong,
              },
              {
                label: this.translate.instant('menu.luongcapbac'),
                icon: 'pi pi-fw pi-sort-amount-up',
                routerLink: '/luongcapbac',
                visible: this.canShowLuongCapBac,
              },
              {
                label: this.translate.instant('menu.luongnangsuat'),
                icon: 'pi pi-fw pi-chart-line',
                routerLink: '/luongnangsuat',
                visible: this.canShowLuongNangSuat,
              },
              {
                label: this.translate.instant('menu.phucap'),
                icon: 'pi pi-fw pi-chart-line',
                routerLink: '/phucap',
                visible: this.canShowPhuCap,
              },
            ],
          },
          {
            label: this.translate.instant('menu.calamviec'),
            icon: 'pi pi-fw pi-exclamation-triangle',
            visible: this.canShowCaLamViec,
            routerLinkActiveOptions: { exact: true },
            routerLink: 'calamviec',
          },
          {
            label: this.translate.instant('menu.baohiem'),
            icon: 'pi pi-fw pi-shield',
            routerLink: '/baohiem',
            visible: this.canShowBaoHiem,
          },
          {
            label: this.translate.instant('menu.thuetncn'),
            icon: 'pi pi-fw pi-percentage',
            routerLink: '/thuetncn',
            visible: this.canShowThueTncn,
          },
          {
            label: this.translate.instant('menu.quanlycong'),
            icon: 'pi pi-fw pi-clock',
            routerLink: '/quanlycong',
            visible: this.canShowQLChamCong,
          },
          {
            label: this.translate.instant('menu.quanlyanca'),
            icon: 'pi pi-fw pi-clock',
            routerLink: '/quanlyanca',
            visible: this.canShowQLAnCa,
          },
          {
            label: this.translate.instant('menu.quanlythunhap'),
            icon: 'pi pi-fw pi-clock',
            routerLink: '/quanlythunhap',
            visible: this.canShowQLThuNhap,
          },
        ],
      },
      {
        label: this.translate.instant('menu.quanlydaotao'),
        icon: 'pi pi-fw pi-graduation-cap',
        visible: this.canShowQlDaoTao,
        items: [
          {
            label: this.translate.instant('menu.daotaohuanluyen'),
            icon: 'pi pi-fw pi-book',
            routerLink: '/daotaohuanluyen',
            visible: this.canShowDthl,
          },
          {
            label: this.translate.instant('menu.nangdinh'),
            icon: 'pi pi-fw pi-star',
            routerLink: '/nangdinh',
            visible: this.canShowNangDinh,
          },
        ],
      },
      {
        label: this.translate.instant('menu.khenthuongkyluat'),
        icon: 'pi pi-fw pi-trophy',
        visible: this.canShowKhenThuongKyLuat,
        items: [
          {
            label: this.translate.instant('menu.khenthuong'),
            icon: 'pi pi-fw pi-star-fill',
            routerLink: '/khenthuong',
            visible: this.canShowKhenThuong,
          },
          {
            label: this.translate.instant('menu.kyluat'),
            icon: 'pi pi-fw pi-ban',
            routerLink: '/kyluat',
            visible: this.canShowKyLuat,
          },
          {
            label: this.translate.instant('menu.nhanxethangnam'),
            icon: 'pi pi-fw pi-list-check',
            routerLink: '/nhanxethangnam',
            visible: this.canShowNhanXetHangNam,
          },
        ],
      },

      {
        label: this.translate.instant('menu.dangdoanthe'),
        icon: 'pi pi-fw pi-receipt',
        visible: this.canShowDangDoanThe,
        items: [
          {
            label: this.translate.instant('menu.dang'),
            icon: 'pi pi-fw pi-bookmark',
            visible: this.canShowDang,
            items: [
              {
                label: this.translate.instant('menu.khenthuongdang'),
                icon: 'pi pi-fw pi-trophy',
                routerLink: '/ktdang',
                visible: this.canShowKhenThuongDang,
              },
              {
                label: this.translate.instant('menu.kyluatdang'),
                icon: 'pi pi-fw pi-ban',
                routerLink: '/kldang',
                visible: this.canShowKyLuatDang,
              },
              {
                label: this.translate.instant('menu.qtctdang'),
                icon: 'pi pi-fw pi-flag',
                routerLink: '/qtctdang',
                visible: this.canShowQtctDang,
              },
              {
                label: this.translate.instant('menu.nhanxethangnamdang'),
                icon: 'pi pi-fw pi-list-check',
                routerLink: '/nxdang',
                visible: this.canShowNhanXetHangNamDang,
              },
            ],
          },
          {
            label: this.translate.instant('menu.congdoan'),
            icon: 'pi pi-fw pi-shopping-bag',
            visible: this.canShowCongDoan,
            items: [
              {
                label: this.translate.instant('menu.khenthuongcongdoan'),
                icon: 'pi pi-fw pi-trophy',
                routerLink: '/ktcongdoan',
                visible: this.canShowKhenThuongCongDoan,
              },
              {
                label: this.translate.instant('menu.kyluatcongdoan'),
                icon: 'pi pi-fw pi-ban',
                routerLink: '/klcongdoan',
                visible: this.canShowKyluatCongDoan,
              },
              {
                label: this.translate.instant('menu.qtctcongdoan'),
                icon: 'pi pi-fw pi-users',
                routerLink: '/qtctcongdoan',
                visible: this.canShowQtctCongDoan,
              },
              {
                label: this.translate.instant('menu.nhanxethangnamcongdoan'),
                icon: 'pi pi-fw pi-list-check',
                routerLink: '/nxcongdoan',
                visible: this.canShowNhanXetHangNamCongDoan,
              },
            ],
          },
          {
            label: this.translate.instant('menu.doanthanhnien'),
            icon: 'pi pi-fw pi-shield',
            visible: this.canShowDoanThanhNien,
            items: [
              {
                label: this.translate.instant('menu.khenthuongdoanthanhnien'),
                icon: 'pi pi-fw pi-trophy',
                routerLink: '/ktdoanthanhnien',
                visible: this.canShowKhenThuongDoanThanhNien,
              },
              {
                label: this.translate.instant('menu.kyluatdoanthanhnien'),
                icon: 'pi pi-fw pi-ban',
                routerLink: '/kldoanthanhnien',
                visible: this.canShowKyLuatDoanThanhNien,
              },
              {
                label: this.translate.instant('menu.qtctdoanthanhnien'),
                icon: 'pi pi-fw pi-heart',
                routerLink: '/qtctdoanthanhnien',
                visible: this.canShowQtctDoanThanhNien,
              },
              {
                label: this.translate.instant('menu.nhanxethangnamdoanthanhnien'),
                icon: 'pi pi-fw pi-list-check',
                routerLink: '/nxdoanthanhnien',
                visible: this.canShowNhanXetHangNamDoanThanhNien,
              },
            ],
          },
        ],
      },
      {
        label: this.translate.instant('menu.detailEmployee'),
        icon: 'pi pi-fw pi-id-card',
        routerLink: '/nhanvien/detail',
        visible: this.canShowNhanVienDetail,
      },
    ];
    this.itemsProfile = [
      {
        label: 'Hi, ' + this.authModel.fullname,
        items: [
          {
            label: this.translate.instant('menu.changePassword'),
            routerLink: '/changePassword',
            icon: 'pi pi-key',
          },
          {
            label: this.translate.instant('menu.logout'),
            icon: 'pi pi-power-off',
            command: (event) => {
              this.logoutHandler();
            },
          },
        ],
      },
    ];

    this.getListWarning();
  }

  ngAfterViewChecked() { }

  ngAfterViewInit() { }

  getListWarning() {
    this.nhanVienService.getListWarning().pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.listWarning = data;
        if (
          this.configService.getShowNotification() &&
          this.listWarning.length > 0
        ) {
          this.displayNoti = true;
        }
      },
      (error) => { }
    );
  }

  showConfig() {
    this.appConfigService.showConfig();
  }

  onRowSelect(event) {
    // this.toastService.success(this.translate.instant('common.label.success'), event.data.hoVaTen);
  }

  logoutHandler() {
    // Call backend logout API
    this.authService.logout().pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        // Clear local storage and session storage
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem('locale', this.locale);

        // Show success message if needed
        if (response && response.status === HttpStatus.OK) {
          this.toastService.success(
            this.translate.instant('common.label.success'),
            this.translate.instant('menu.logout_success')
          );
        }

        // Navigate to login page
        this.router.navigateByUrl('/login');
      },
      (error) => {
        // Even if logout API fails, still clear local data and navigate
        console.error('Logout API error:', error);
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem('locale', this.locale);
        this.router.navigateByUrl('/login');
      }
    );
  }

  showPositionDialog(position: string) {
    this.position = position;
    this.displayPosition = true;
  }

  swicthLang() {
    if (this.locale === 'vi') {
      this.locale = 'en';
      localStorage.setItem('locale', 'en');
    } else {
      this.locale = 'vi';
      localStorage.setItem('locale', 'vi');
    }
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
